import { ProductTypeENUM } from '../../enums/ProductEnums';
import { PriceDTO } from '../../generic-models/DTOs/PriceDTO';
import { getProductDTOsDefaultAttributeSettings } from '../../utils';
import { AttributeSettingsDTO } from './AttributeSettingsDTO';
import { ChildProductDTO } from './ChildProductDTO';
import { FloorplanDTO } from './FloorplanDTO';
import { ProductBlueprintDTO } from './ProductBlueprintDTO';
import { TransformationDataDTO } from './TransformationDataDTO';

export class ProductDTO {
  public static createProductDTOFromProductBlueprintDTO(productBlueprintDTO: ProductBlueprintDTO) {
    const newProductDTO = new ProductDTO(
      undefined,
      productBlueprintDTO.id ? Number(productBlueprintDTO.id) : null,
      [],
      new TransformationDataDTO(undefined, [0, 0, 0], [0, 0, 0]),
      [],
      FloorplanDTO.getEmptyFloorplan(),
      undefined,
    );

    newProductDTO.attributeSettings = getProductDTOsDefaultAttributeSettings(productBlueprintDTO);
    return newProductDTO;
  }

  public static getEmptyProduct(productBlueprintId: number) {
    return new ProductDTO(
      undefined,
      productBlueprintId,
      [],
      new TransformationDataDTO(undefined, [0, 0, 0], [0, 0, 0]),
      [],
      null,
      '',
    );
  }

  id: number | undefined;
  productBlueprintId: number | null;
  products: ChildProductDTO[];
  transformationData: TransformationDataDTO;
  attributeSettings: AttributeSettingsDTO[];
  floorplan: FloorplanDTO | null;
  wallId: string | undefined;
  productType?: ProductTypeENUM;
  userComment?: string;
  imageData2dURL?: string;
  imageData3dURL?: string;
  imageData2dBase64?: string;
  imageData3dBase64?: string;
  configurationURL?: string;
  thumbnailUrl?: string;
  price?: PriceDTO;
  isFromStorage = false;

  constructor(
    id: number | undefined,
    productBlueprintId: number | null,
    products: ChildProductDTO[],
    transformationData: TransformationDataDTO,
    attributeSettings: AttributeSettingsDTO[],
    floorplan: FloorplanDTO | null,
    wallId: string | undefined,
    productType?: ProductTypeENUM,
    userComment?: string,
    imageData2dURL?: string,
    imageData3dURL?: string,
    imageData2dBase64?: string,
    imageData3dBase64?: string,
    configurationURL?: string,
    thumbnailUrl?: string,
    price?: PriceDTO,
  ) {
    this.id = id;
    this.productBlueprintId = productBlueprintId;
    this.products = products;
    this.transformationData = transformationData;
    this.attributeSettings = attributeSettings;
    this.floorplan = floorplan;
    this.userComment = userComment;
    this.imageData2dURL = imageData2dURL;
    this.imageData3dURL = imageData3dURL;
    this.imageData2dBase64 = imageData2dBase64;
    this.imageData3dBase64 = imageData3dBase64;
    this.configurationURL = configurationURL;
    this.thumbnailUrl = thumbnailUrl;
    this.wallId = wallId;
    this.productType = productType;
    this.price = price;
  }
}
